// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + "ff3fe17658b7d65d2bc5" + ".js";
};